import { Formik } from "formik";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import FormDisplay from "./FormDisplay";
import pages from "../../../constants/pages";
import { useAxios, useAlert } from "../../../hooks";
import { signInMember } from "../../../redux/slices/memberSlice";
import { settingDetailsObject, validationSchema } from "./settingDetailsObject";

export default function Form() {
  const axios = useAxios({ disableAuthToken: false });

  const { alert } = useAlert();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Formik
      enableReinitialize
      initialValues={settingDetailsObject}
      validationSchema={validationSchema}
      validateOnMount
      onSubmit={(formData, { setSubmitting }) => {
        axios({
          url: "/change-password",
          method: "POST",
          data: {
            old_password: formData.oldPassword,
            password1: formData.newPassword,
            password2: formData.password,
          },
          disableRedirect: true,
        })
          .then((res) => {
            console.log(res);
            if (res.status) {
              dispatch(
                signInMember({
                  authToken: res.data.auth_token,
                })
              );

              dispatch(
                alert({ message: res.message.displayMessage, type: "success" })
              );

              navigate(pages.signIn.route);
            }

            setSubmitting(false);
          })
          .catch((err) => {
            console.error(err);
          });
      }}
    >
      {(formikProps) => (
        <form onSubmit={formikProps.handleSubmit}>
          <FormDisplay formikProps={formikProps} />
        </form>
      )}
    </Formik>
  );
}
